import Vue from 'vue'
import Router from 'vue-router'
import ListView from '@/views/ListView.vue'
//import FormView from '@/views/FormView.vue'
import ShopView from '@/views/ShopView.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'list',
      component: ListView,
      meta:{
        seo:{
          title: "vonTablern.de",
          link: [
            {rel: 'canonical', href: 'https://www.vontablern.de'}
          ],
          meta: [
              { name: 'title', content: 'vonTablern.de'},
              { name: 'description', content: 'Kauf direkt und ohne Umwege von Ladies & Tablern'},
              { name: 'author', content: 'Tobias Hubold'},
              { property: 'og:title', content: "vonTablern.de"},
              { property: 'og:type', content: 'website'},
              { property: 'og:image', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'og:image:type', content: 'image/jpeg'},
              { property: 'og:description', content: 'Kauf direkt und ohne Umwege von Ladies & Tablern'},
              { property: 'og:url', content: 'https://www.vontablern.de'},
              { property: 'og:site_name', content: 'vontablern.de'},
              { property: 'twitter:image:alt', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'twitter:card', content: 'Kauf direkt und ohne Umwege von Ladies & Tablern'},
          ]
        }
      }
    },
    {
      path: '/formular/',
      name: 'formular',
      component: () => import('./views/FormView.vue'),
      meta:{
        seo:{
          title: "Unternehmen eintragen",
          link: [
            {rel: 'canonical', href: 'https://www.vontablern.de/eintragen'}
          ],
          meta: [
              { name: 'title', content: 'Unternehmen eintragen'},
              { name: 'description', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
              { name: 'author', content: 'Tobias Hubold'},
              { property: 'og:title', content: "Unternehmen eintragen"},
              { property: 'og:type', content: 'website'},
              { property: 'og:image', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'og:image:type', content: 'image/jpeg'},
              { property: 'og:description', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
              { property: 'og:url', content: 'https://www.vontablern.de/formular'},
              { property: 'og:site_name', content: 'vontablern.de'},
              { property: 'twitter:image:alt', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'twitter:card', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
          ]
        }
      }
    },
    {
      path: '/eintragen/',
      name: 'eintragen',
      component: () => import('./views/FormView.vue'),
      meta:{
        seo:{
          title: "Unternehmen eintragen",
          link: [
            {rel: 'canonical', href: 'https://www.vontablern.de/eintragen'}
          ],
          meta: [
              { name: 'title', content: 'Unternehmen eintragen'},
              { name: 'description', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
              { name: 'author', content: 'Tobias Hubold'},
              { property: 'og:title', content: "Unternehmen eintragen"},
              { property: 'og:type', content: 'website'},
              { property: 'og:image', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'og:image:type', content: 'image/jpeg'},
              { property: 'og:description', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
              { property: 'og:url', content: 'https://www.vontablern.de/eintragen'},
              { property: 'og:site_name', content: 'vontablern.de'},
              { property: 'twitter:image:alt', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'twitter:card', content: 'Trage dein Unternehmen in die Übersicht bei vontablern.de ein'},
          ]
        }
      }
    },
    {
      path: '/about/',
      name: 'about',
      component: () => import('./views/AboutView.vue'),
      meta:{
        seo:{
          title: "Unterstützung",
          link: [
            {rel: 'canonical', href: 'https://www.vontablern.de/about'}
          ],
          meta: [
              { name: 'title', content: 'Unterstützung'},
              { name: 'description', content: 'Trage mit einer kleinen Unterstützung zum Ausbau und Erhalt von vonTablern.de bei'},
              { name: 'author', content: 'Tobias Hubold'},
              { property: 'og:title', content: "Unterstützung"},
              { property: 'og:type', content: 'website'},
              { property: 'og:image', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'og:image:type', content: 'image/jpeg'},
              { property: 'og:description', content: 'Trage mit einer kleinen Unterstützung zum Ausbau und Erhalt von vonTablern.de bei'},
              { property: 'og:url', content: 'https://www.vontablern.de/about'},
              { property: 'og:site_name', content: 'vontablern.de'},
              { property: 'twitter:image:alt', content: 'https://vontablern.de/images/preview.jpg'},
              { property: 'twitter:card', content: 'Trage mit einer kleinen Unterstützung zum Ausbau und Erhalt von vonTablern.de bei'},
          ]
        }
      }
    },
    {
      path: '/thankyou/',
      name: 'thankyou',
      component: () => import('./views/ThankYou.vue'),
      meta:{}
    },
    {
      path: '/shop/:id',
      name: 'shop',
      component: ShopView,
      props: true 
    }
  ]
})
